import bizError from './index';
import tools from '../util/tools';
export default function (bizErrors) {
    bizErrors.forEach(function (element) {
        if (!tools.arrayContains(bizError, element)) {
            bizError.push(element);
        }
    });
}

//# sourceMappingURL=registerBizError.js.map
